export var AXES_TITLES_WIDGETS = ['line', 'area', 'bar', 'heatmap'];